function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FeedColumnLayoutIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H0V0h16v16zM1 15h14V1H1v14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36.5h1v14.89h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 9h5.36v1H.5zM.5 12h5.36v1H.5zM.5 3h5.36v1H.5zM.5 6h5.36v1H.5z"
  }));
};
export default FeedColumnLayoutIcon;